var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "testimony" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("h2", [_vm._v("Veja o que estão falando da gente")]),
            _vm._v(" "),
            _c(
              "carousel",
              {
                staticClass: "carousel",
                attrs: {
                  autoplay: true,
                  perPage: 1,
                  paginationEnabled: true,
                  autoplayHoverPause: true,
                  loop: true,
                  autoplayTimeout: 5000
                }
              },
              [
                _c("slide", { staticClass: "slide" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8" }, [
                      _c("p", [
                        _vm._v(
                          "\n                    “A plataforma Click2giv nos proporciona divulgação do nosso trabalho, além de levar as nossas propostas \n                    mais longe e a mais pessoas. Por outro lado, no que diz respeito à captação de recursos, tem um papel \n                    fundamental, pois é uma ferramenta acessível às pessoas que desejam fazer suas doações, com maior facilidade \n                    e de acordo com suas possibilidades.”\n                    "
                        ),
                        _c("br"),
                        _c("b", [
                          _vm._v(
                            "(José Carlos de Gomes Oliveira - Presidente Centro Social Roger Cunha)"
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("img", { attrs: { src: _vm.testimony6 } })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("slide", { staticClass: "slide" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8" }, [
                      _c("p", [
                        _vm._v(
                          "\n                    “Não temos dúvida que grande parte do sucesso da campanha da AESB/AACD se deveu a facilidade de acesso e \n                    a credibilidade da plataforma Click2giv. Nos sentimos muito satisfeitos e alegres de saber que temos pessoas \n                    envolvidas, de diversas áreas, para promover o bem e, no caso da plataforma, para facilitar a divulgação e \n                    obtenção de recursos para projetos sociais. Exemplo que todos podemos ser agentes de transformação, que a cada\n                     dia certamente terá mais seguidores”\n                    "
                        ),
                        _c("br"),
                        _c("b", [
                          _vm._v(
                            "(Paulo Dutra - Associação de Ex-Alunos Escola Senai Suiço Brasileira)"
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("img", { attrs: { src: _vm.testimony4 } })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("slide", { staticClass: "slide" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8" }, [
                      _c("p", [
                        _vm._v(
                          "\n                    “Com a transformação digital a plataforma Click2giv facilitou  o processo de Captação de Recursos da AFAGO-SP, \n                    apresentando uma ferramenta simples, transparente para a divulgação de nossas campanhas, contribuindo para que \n                    um número ilimitado de pessoas conheça as nossas ações e doe para os projetos através de um clique.”\n                    "
                        ),
                        _c("br"),
                        _c("b", [_vm._v("(Ana Paula Dias - Gestora AFAGO-SP)")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("img", { attrs: { src: _vm.testimony5 } })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("slide", { staticClass: "slide" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8" }, [
                      _c("p", [
                        _vm._v(
                          "\n                    ¨”A Click2giv possui uma equipe sempre pronta a nos ajudar a entender nossos desafios\n                    e principalmente propor soluções simples, práticas e efetivas. A grande experiência\n                    tanto no mundo corporativo quanto no terceiro setor, é sem dúvida um diferencial \n                    importante para o sucesso da nossa parceria.” "
                        ),
                        _c("br"),
                        _c("b", [
                          _vm._v(
                            "(Any Bittar - Diretora Executiva Projeto Casulo)"
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("img", { attrs: { src: _vm.testimony1 } })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("slide", { staticClass: "slide" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("img", { attrs: { src: _vm.testimony2 } })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-8" }, [
                      _c("p", [
                        _vm._v(
                          "\n                    “A Click2giv é uma verdadeira plataforma social. As organizações sociais inserem\n                    seus projetos e recebem 100% de retorno das doações, descontadas apenas as taxas\n                    de operação bancária. Além da plataforma não cobrar nenhuma taxa das organizações,\n                    os fundadores estão empenhados em conhecer de perto o trabalho de cada organização,\n                    além de ajudarem dando dicas e informações importantes para que o seu projeto tenha\n                    sucesso.” "
                        ),
                        _c("br"),
                        _c("b", [
                          _vm._v(
                            "(Eliane Miada - Presidente ADD Associação Desportiva para Deficientes)"
                          )
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("slide", { staticClass: "slide" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8" }, [
                      _c("p", [
                        _vm._v(
                          '\n                    "Neste mais de um ano junto com a Click2giv descobrimos que a plataforma é muito\n                    mais que uma ferramenta para recebimento de doações sem cobrança de taxas, \n                    a verdadeira essência da click2giv  é conectar pessoas que estão fazendo o bem, \n                    com pessoas que querem fazer o bem. Nosso projeto já cresceu muito com as conexões \n                    feitas pela click2giv, posso citar como grandes avanços a oficialização da nossa ONG \n                    e a otimização do projeto da cadeira Julietti, tudo graças às conexões da plataforma" \n                    '
                        ),
                        _c("br"),
                        _c("b", [
                          _vm._v(
                            "(Guilherme Simões - Fundador Projeto Montanha para Todos)"
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("img", { attrs: { src: _vm.testimony3 } })
                    ])
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-689c689e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-689c689e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/TestimonySection.vue
// module id = null
// module chunks = 